import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";


export const getTenderStatus = createAsyncThunk("getTenderStatus", async (_, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.get("status/list?identifier=tenders");
          return Array.isArray(response?.data?.data) ? response.data.data : [];
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

export const updateTender = createAsyncThunk("updateTender", async ({ tenderId, payload }, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.put(`tms/tenders/${tenderId}`, payload);
          return response.data;
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

export const getTender = createAsyncThunk("getTender", async (tenderId, { rejectWithValue }) => {
     try {
          const response = await axiosHttp.get(`tms/tenders/${tenderId}`);
          return response.data;
     } catch (err) {
          if (!err.response) throw err;
          return rejectWithValue(err.response.data);
     }
});

const TenderUpdateSlice = createSlice({
     name: "TenderUpdateSlice",
     initialState: {
          isLoading: false,
          data: null,
          error: null,
          tenderStatusLoading: false,
          tenderStatus: [],
          tenderStatusError: null,
          tenderDataLoading: false,
          tenderData: null,
          tenderDataError: null,
     },
     reducers: {
          resetTenderUpdate: (state) => {
               state.isLoading = false;
               state.data = null;
               state.error = null;
          },
     },
     extraReducers: (builder) => {
          builder.addCase(getTenderStatus.pending, (state) => {
               state.tenderStatusLoading = true;
               state.tenderStatusError = null;
          });
          builder.addCase(getTenderStatus.fulfilled, (state, action) => {
               state.tenderStatusLoading = false;
               state.tenderStatus = action.payload;
          });
          builder.addCase(getTenderStatus.rejected, (state, action) => {
               state.tenderStatusLoading = false;
               state.tenderStatusError = action.payload?.data;
          });

          // updateTender extra reducers
          builder.addCase(updateTender.pending, (state) => {
               state.isLoading = true;
               state.error = null;
          });
          builder.addCase(updateTender.fulfilled, (state, action) => {
               state.isLoading = false;
               state.data = action.payload;
          });
          builder.addCase(updateTender.rejected, (state, action) => {
               state.isLoading = false;
               state.error = action.payload;
          });

          // getTender mapping
          builder.addCase(getTender.pending, (state) => {
               state.tenderDataLoading = true;
               state.tenderDataError = null;
               state.tenderData = null;
          });
          builder.addCase(getTender.fulfilled, (state, action) => {
               state.tenderDataLoading = false;
               state.tenderData = action.payload?.data;
          });
          builder.addCase(getTender.rejected, (state, action) => {
               state.tenderDataLoading = false;
               state.tenderDataError = action.payload?.data;
          });
     },
});

export const { resetTenderUpdate } = TenderUpdateSlice.actions;
export const { resetTenderStatus } = TenderUpdateSlice.actions;
export default TenderUpdateSlice.reducer;

